import {Mediator} from "@dp-instant/2d";
import {inject, injectable} from "inversify";
import {Point} from "pixi.js-legacy";
import {GameEvents} from "../GameEvents";
import {CapitalView} from "../view/CapitalView";
import {ArrowsView} from "../view/ArrowsView";
import {GameModel} from "../model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {Building} from "@game/coregame/ecs/entities/Building";

@injectable()
export class ArrowsMediator extends Mediator {
    @inject(TypesGame.model)
    protected model: GameModel;
    protected view: ArrowsView;

    initialize() {
        this.addListener(GameEvents.AIM_UPDATE, (event: PointerEvent) => this.view.update(event));
        this.addListener(GameEvents.AIM_CREATE, (building: Building) => this.view.createArrow(building));
        this.addListener(GameEvents.AIM_REMOVE, () => this.view.removeAim());
        this.addListener(GameEvents.AIM_SET, (point: Point) => this.view.setAim(point));
        this.addListener(GameEvents.AIM_HIDE, (building: Building) => this.view.hideArrow(building));
    }
}
